const ApuracaoContrato = () => import('@/spa/apuracao-contrato/ApuracaoContrato');

export default {
  path: 'apuracao-contrato',
  name: 'apuracao-contrato',
  component: ApuracaoContrato,
};
